import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import SvgIcon from "@mui/material/SvgIcon";
import classnames from "classnames";
import { useStyles } from "./Reactions.styles.js";
const HeartIcon = (t0)=>{
    const $ = c(20);
    const { size: t1, color: t2 } = t0;
    const size = void 0 === t1 ? "default" : t1;
    const color = void 0 === t2 ? "secondary" : t2;
    const { classes } = useStyles();
    const t3 = classes[`icon_size_${size}`];
    const t4 = classes[`icon_color_${color}`];
    let t5;
    if ($[0] !== t3 || $[1] !== t4) {
        t5 = classnames(t3, t4);
        $[0] = t3;
        $[1] = t4;
        $[2] = t5;
    } else t5 = $[2];
    let t6;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ jsx("path", {
            d: "M16.1226 3.93061C14.3623 2.6285 11.5735 2.71469 10.0702 4.37749C9.98392 4.47296 9.82976 4.4709 9.74466 4.37435C8.37635 2.82181 5.42899 2.59524 3.68822 3.93061C2.20555 5.06799 1.27509 7.86602 3.48275 11.5607C5.23647 14.4956 8.20258 16.7419 9.90541 16.7419C11.6082 16.7419 14.6382 14.6807 16.4901 11.5607C18.7195 7.80452 17.623 5.04047 16.1226 3.93061Z",
            fill: "url(#paint0_linear_4706_230033)"
        });
        $[3] = t6;
    } else t6 = $[3];
    let t7;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ jsx("path", {
            d: "M16.1226 3.93061C14.3623 2.6285 11.5735 2.71469 10.0702 4.37749C9.98392 4.47296 9.82976 4.4709 9.74466 4.37435C8.37635 2.82181 5.42899 2.59524 3.68822 3.93061C2.20555 5.06799 1.27509 7.86602 3.48275 11.5607C5.23647 14.4956 8.20258 16.7419 9.90541 16.7419C11.6082 16.7419 14.6382 14.6807 16.4901 11.5607C18.7195 7.80452 17.623 5.04047 16.1226 3.93061Z",
            fill: "url(#paint1_radial_4706_230033)",
            style: {
                mixBlendMode: "lighten"
            }
        });
        $[4] = t7;
    } else t7 = $[4];
    let t8;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ jsx("path", {
            d: "M16.1226 3.93061C14.3623 2.6285 11.5735 2.71469 10.0702 4.37749C9.98392 4.47296 9.82976 4.4709 9.74466 4.37435C8.37635 2.82181 5.42899 2.59524 3.68822 3.93061C2.20555 5.06799 1.27509 7.86602 3.48275 11.5607C5.23647 14.4956 8.20258 16.7419 9.90541 16.7419C11.6082 16.7419 14.6382 14.6807 16.4901 11.5607C18.7195 7.80452 17.623 5.04047 16.1226 3.93061Z",
            fill: "url(#paint2_radial_4706_230033)",
            style: {
                mixBlendMode: "lighten"
            }
        });
        $[5] = t8;
    } else t8 = $[5];
    let t9;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ jsx("g", {
            opacity: "0.8",
            children: /*#__PURE__*/ jsx("path", {
                d: "M9.64071 7.35514C9.34581 5.66001 9.88922 4.7293 10.0124 4.4297C9.75038 4.50123 9.71625 4.27806 9.44965 4.0816C8.86763 3.56533 8.12723 3.32794 8.12723 3.32794C8.12723 3.32794 7.75906 6.09735 9.64071 7.35514Z",
                fill: "url(#paint3_radial_4706_230033)",
                style: {
                    mixBlendMode: "lighten"
                }
            })
        });
        $[6] = t9;
    } else t9 = $[6];
    let t10;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ jsx("g", {
            opacity: "0.8",
            filter: "url(#filter0_f_4706_230033)",
            children: /*#__PURE__*/ jsx("path", {
                d: "M6.56962 10.2246C8.58788 9.73725 9.91882 7.78852 9.54236 5.87197C9.16591 3.95542 7.22461 2.79681 5.20635 3.28414C3.1881 3.77147 1.85716 5.7202 2.23361 7.63675C2.61007 9.5533 4.55137 10.7119 6.56962 10.2246Z",
                fill: "url(#paint4_radial_4706_230033)"
            })
        });
        $[7] = t10;
    } else t10 = $[7];
    let t11;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ jsxs("g", {
            clipPath: "url(#clip0_4706_230033)",
            children: [
                t6,
                t7,
                t8,
                t9,
                t10,
                /*#__PURE__*/ jsx("g", {
                    opacity: "0.9",
                    filter: "url(#filter1_f_4706_230033)",
                    children: /*#__PURE__*/ jsx("path", {
                        d: "M11.7682 9.24286C13.7235 10.4506 16.1421 10.2473 17.1701 8.78865C18.1982 7.33004 17.4465 5.16854 15.4912 3.96079C13.5359 2.75304 11.1173 2.95641 10.0893 4.41501C9.06119 5.87361 9.81287 8.03512 11.7682 9.24286Z",
                        fill: "url(#paint5_radial_4706_230033)"
                    })
                })
            ]
        });
        $[8] = t11;
    } else t11 = $[8];
    let t12;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ jsxs("filter", {
            id: "filter0_f_4706_230033",
            x: "-17.8301",
            y: "-16.8271",
            width: "47.4365",
            height: "47.1631",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
                /*#__PURE__*/ jsx("feFlood", {
                    floodOpacity: "0",
                    result: "BackgroundImageFix"
                }),
                /*#__PURE__*/ jsx("feBlend", {
                    mode: "normal",
                    in: "SourceGraphic",
                    in2: "BackgroundImageFix",
                    result: "shape"
                }),
                /*#__PURE__*/ jsx("feGaussianBlur", {
                    stdDeviation: "10",
                    result: "effect1_foregroundBlur_4706_230033"
                })
            ]
        });
        $[9] = t12;
    } else t12 = $[9];
    let t13;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = /*#__PURE__*/ jsxs("filter", {
            id: "filter1_f_4706_230033",
            x: "-10.3711",
            y: "-16.8271",
            width: "48.002",
            height: "46.8584",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
                /*#__PURE__*/ jsx("feFlood", {
                    floodOpacity: "0",
                    result: "BackgroundImageFix"
                }),
                /*#__PURE__*/ jsx("feBlend", {
                    mode: "normal",
                    in: "SourceGraphic",
                    in2: "BackgroundImageFix",
                    result: "shape"
                }),
                /*#__PURE__*/ jsx("feGaussianBlur", {
                    stdDeviation: "10",
                    result: "effect1_foregroundBlur_4706_230033"
                })
            ]
        });
        $[10] = t13;
    } else t13 = $[10];
    let t14;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = /*#__PURE__*/ jsxs("linearGradient", {
            id: "paint0_linear_4706_230033",
            x1: "9.90926",
            y1: "4.23334",
            x2: "12.2357",
            y2: "17.9071",
            gradientUnits: "userSpaceOnUse",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FF4F37"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.42",
                    stopColor: "#EA002D"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#D30D81"
                })
            ]
        });
        $[11] = t14;
    } else t14 = $[11];
    let t15;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint1_radial_4706_230033",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(7.00258 7.29804) rotate(45.6577) scale(10.3166 12.099)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.395833",
                    stopColor: "#FF4570",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.790094",
                    stopColor: "#750A77",
                    stopOpacity: "0.8"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.994222",
                    stopColor: "#F459AD"
                })
            ]
        });
        $[12] = t15;
    } else t15 = $[12];
    let t16;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint2_radial_4706_230033",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(9.81653 10.2795) rotate(-89.2763) scale(7.24683 9.92687)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.801724",
                    stopColor: "#FE789B",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#F11414",
                    stopOpacity: "0.41"
                })
            ]
        });
        $[13] = t16;
    } else t16 = $[13];
    let t17;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint3_radial_4706_230033",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(9.82417 4.60584) rotate(153.646) scale(3.16003 2.94526)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.106246",
                    stopColor: "#CA1010"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.681366",
                    stopColor: "#FF3537",
                    stopOpacity: "0"
                })
            ]
        });
        $[14] = t17;
    } else t17 = $[14];
    let t18;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint4_radial_4706_230033",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(5.91366 6.673) rotate(-13.5749) scale(3.78255 3.55503)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FFB6B6",
                    stopOpacity: "0.6"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FF0027",
                    stopOpacity: "0"
                })
            ]
        });
        $[15] = t18;
    } else t18 = $[15];
    let t19;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t19 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint5_radial_4706_230033",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(13.7796 6.73073) rotate(31.7023) scale(4.10559 3.18197)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FF9999",
                    stopOpacity: "0.6"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FF1F1F",
                    stopOpacity: "0"
                })
            ]
        });
        $[16] = t19;
    } else t19 = $[16];
    let t20;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t20 = /*#__PURE__*/ jsxs("defs", {
            children: [
                t12,
                t13,
                t14,
                t15,
                t16,
                t17,
                t18,
                t19,
                /*#__PURE__*/ jsx("clipPath", {
                    id: "clip0_4706_230033",
                    children: /*#__PURE__*/ jsx("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            ]
        });
        $[17] = t20;
    } else t20 = $[17];
    let t21;
    if ($[18] !== t5) {
        t21 = /*#__PURE__*/ jsxs(SvgIcon, {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: t5,
            children: [
                t11,
                t20
            ]
        });
        $[18] = t5;
        $[19] = t21;
    } else t21 = $[19];
    return t21;
};
export { HeartIcon };
